import { FC, memo } from 'react';

import cn from 'classnames';

import styles from './timelineSection.module.scss';

const TimelineSection: FC = () => {
  return (
    <div className={styles.sectionBox}>
      <div className={styles.sectionTitle}>
        <span>Timeline (CTA schedule overview)</span>
        <div className={styles.timelineLegend}>
          <span className={styles.bulletSection}>
            <div className={cn(styles.bullet, styles.bulletMyCta)} />
            My CTA
          </span>
          <span className={styles.bulletSection}>
            <div className={cn(styles.bullet, styles.bulletOccupied)} />
            Occupied
          </span>
          <span className={styles.bulletSection}>
            <div className={cn(styles.bullet, styles.bulletSelected)} />
            Selected
          </span>
        </div>
      </div>
      <div className={styles.timelineContainer}>
        <div className={styles.timelineVisual}>
          <div className={styles.timelineBarFilled}></div>
        </div>
        <div className={styles.timelineLabels}>
          <span>0:00</span>
          <span>10:00</span>
          <span>20:00</span>
          <span>30:00</span>
          <span>40:00</span>
          <span>50:00</span>
          <span>60:00</span>
        </div>
      </div>
    </div>
  );
};

export default memo(TimelineSection);
